import { asyncDebounce } from "@shared/helpers";
import useStatic from "./useStatic";

export default function useAsyncDebounce<T extends (...args: any) => any>(fn: T, timeout: number) {
    return useStatic(asyncDebounce(fn, timeout))
}